import React, { Component } from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';

// pages
import Home from './pages/Home';
import Impressum from './pages/Impressum';

// components
import Navbar from './components/Navbar';
import Footer from './components/Footer';

// logos
import mainLogo from './logos/Hauptlogo.png';

// constants
const NAV_HEIGHT = 80;


class App extends Component {
  constructor(props) {
    super(props);
    this.nav = React.createRef();
  }

  render() {
    return (
      <HashRouter>
        <Navbar ref={this.nav} logo={mainLogo} color={'#888'} height={NAV_HEIGHT} />
        <Switch>
          <Route path='/Impressum' component={() => <Impressum />} />
          <Route path='/' component={() => <Home navHeight={NAV_HEIGHT} />} />
        </Switch>
        <Footer />
      </HashRouter>

    );
  }
}

export default App;
